<template>
	<a-modal width="55%" title="详情" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
		:confirm-loading="confirmLoading" :footer="null" @ok="onSubmit" @cancel="onClose">
		<a-descriptions :column="2" title='申请信息'>
			<a-descriptions-item label="兑现年份">{{ form.year }}</a-descriptions-item>
			<a-descriptions-item label="企业名称">{{ form.companyName }}</a-descriptions-item>
			<a-descriptions-item label="统一社会信用代码">{{ form.oraganizationCode }}</a-descriptions-item>
			<a-descriptions-item label="企业注册地址">{{ form.detailedAddress }}</a-descriptions-item>
			<a-descriptions-item label="经办人">{{ form.agent }}</a-descriptions-item>
			<a-descriptions-item label="经办人联系电话">{{ form.agentPhone }}</a-descriptions-item>
			<a-descriptions-item label="经办人身份证号">{{ form.agentIdCard }}</a-descriptions-item>
			<a-descriptions-item label="邮箱">{{ form.email }}</a-descriptions-item>
			<a-descriptions-item label="依据政策拟申请金额（万元）">{{ form.amountApplied }}</a-descriptions-item>
			<a-descriptions-item label="高企编号">{{ form.highNumber }}</a-descriptions-item>
			<a-descriptions-item label="发证时间">{{ form.issuingTime && form.issuingTime ?
				form.issuingTime.split(' ')[0] : ''
			}}</a-descriptions-item>
			<a-descriptions-item label="开户行">{{ form.openingBank }}</a-descriptions-item>
			<a-descriptions-item label="账号">{{ form.accountNumber }}</a-descriptions-item>
			<a-descriptions-item label="行号">{{ form.lineNumber }}</a-descriptions-item>
			<a-descriptions-item label="提交时间">{{ form.submitTime }}</a-descriptions-item>
			<a-descriptions-item label="开户行许可证" name="bankPermitFile">
				<file-upload v-model:value="form.bankPermitFile" :showBtn="false" disabled />
			</a-descriptions-item>
			<!-- <a-descriptions-item label="承诺书" name="promiseFile">
				<file-upload v-model:value="form.promiseFile" :showBtn="false" disabled />
			</a-descriptions-item> -->
			<a-descriptions-item label="其他相应印证资料" name="correspondingCorroboratingDataFile">
				<file-upload v-model:value="form.correspondingCorroboratingDataFile" :showBtn="false" disabled />
			</a-descriptions-item>
            <a-descriptions-item label="政策依据">{{ form.policyBasis }}</a-descriptions-item>
		</a-descriptions>
        <!--提交之后 未初审-->
        <a-descriptions :column="2" title='园区确认信息' v-if="form.isSubmit != 0 && form.isSubmit != 5">
            <a-descriptions-item label="确认状态">
                <span v-if="form.notarizeStatus==1" style="color:green">确认通过</span>
                <span v-if="form.notarizeStatus==2" style="color:red">确认未通过</span>
            </a-descriptions-item>
            <a-descriptions-item label="确认时间">{{ form.notarizeTime }}</a-descriptions-item>
            <a-descriptions-item label="确认原因" :span="2" >{{ form.notarizeRemark }}</a-descriptions-item>
        </a-descriptions>
		<!-- 有一个审核不通过时 -->
		<a-descriptions :column="2" title='初审信息'
			v-if="form.auditStatus == 3 || (form.firstAuditStatus != 0 && form.secondAuditStatus == 0)">
            <a-descriptions-item label="初审状态">
                <span v-if="form.firstAuditStatus==1" style="color:green">通过</span>
                <span v-if="form.firstAuditStatus==2" style="color:red">不通过</span>
            </a-descriptions-item>
			<a-descriptions-item label="初审时间">{{ form.firstAuditTime }}</a-descriptions-item>
			<a-descriptions-item label="初审原因" :span="2">{{ form.firstAuditRemark }}</a-descriptions-item>
		</a-descriptions>
		<a-descriptions :column="2" title='复审信息'
			v-if="form.auditStatus == 3 && (form.firstAuditStatus != 0 && form.secondAuditStatus != 0)">
            <a-descriptions-item label="复审状态">
                <span v-if="form.secondAuditStatus==1" style="color:green">通过</span>
                <span v-if="form.secondAuditStatus==2" style="color:red">不通过</span>
            </a-descriptions-item>
      <a-descriptions-item label="复审时间">{{ form.secondAuditTime }}</a-descriptions-item>
			<a-descriptions-item label="复审原因" :span="2">{{ form.secondAuditRemark }}</a-descriptions-item>
		</a-descriptions>
		<!-- 审核全部通过时 -->
		<a-descriptions :column="2" title='初审信息'
			v-if="form.auditStatus == 2">
            <a-descriptions-item label="初审状态">
                <span v-if="form.firstAuditStatus==1" style="color:green">通过</span>
                <span v-if="form.firstAuditStatus==2" style="color:red">不通过</span>
            </a-descriptions-item>
			<a-descriptions-item label="初审时间">{{ form.firstAuditTime }}</a-descriptions-item>
			<a-descriptions-item label="初审原因" :span="2">{{ form.firstAuditRemark }}</a-descriptions-item>
		</a-descriptions>
		<a-descriptions :column="2" title='复审信息'
			v-if="form.auditStatus == 2">
            <a-descriptions-item label="复审状态">
                <span v-if="form.secondAuditStatus==1" style="color:green">通过</span>
                <span v-if="form.secondAuditStatus==2" style="color:red">不通过</span>
            </a-descriptions-item>
      <a-descriptions-item label="复审时间">{{ form.secondAuditTime }}</a-descriptions-item>
			<a-descriptions-item label="复审原因" :span="2">{{ form.secondAuditRemark }}</a-descriptions-item>
		</a-descriptions>

        <a-descriptions :column="2" title='财审信息' v-if="form.secondAuditStatus == 1 && form.opinionStatus == 1">
            <a-descriptions-item label="意见" :span="2">{{ form.opinion}}</a-descriptions-item>
        </a-descriptions>
	</a-modal>
</template>
<script>
import { formMixin } from "@/mixins";
export default {
	name: "DetailModal",
	components: {
	},

	mixins: [formMixin],
	data() {
		return {
			form: {
				parentId: null,
			},
		}
	},
}
</script>
<style scoped lang="less"></style>
